define('GameDayCore/GDModel/ValueObjects/Game/GameFileStadium',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(GameFileStadium);

	function GameFileStadium($data) {
		var vo = VO.ensureVO(this, GameFileStadium),
			data = $data;

		vo.id = data.id || "";
		vo.name = data.name || "";
		vo.location = data.location || "";
		vo.venue_w_chan_loc = data.venue_w_chan_loc || "";
	}

	return GameFileStadium;
});
